/**
 * Module principal permettant d'importer les librairies nécessaires à l'application.
 *
 * @author Francis Chabot
 * @module index
 *
 * @see Bootstrap {@link https://getbootstrap.com/}
 * @see Font Awesome Free {@link https://fontawesome.com/free}
 * @see React {@link https://reactjs.org/}
 * @see create-react-apps {@link https://github.com/facebook/create-react-app}
 * @see react-responsive-modal {@link https://github.com/pradel/react-responsive-modal}
 * @see JSDoc {@link http://usejsdoc.org/}
 * @see HTML5Boilerplate {@link https://html5boilerplate.com/}
 *
 * @version 0.5.0 le 3 janvier 2019
 */

// Polyfill
import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";

import React from "react";
import ReactDOM from "react-dom";

import App from "./App";

import "bootstrap/dist/css/bootstrap.min.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "./index.css";

// Unregister an existing service worker
import { unregister } from "./registerServiceWorker";
unregister();

console.log(process.env.REACT_APP_ENV);

ReactDOM.render(<App />, document.getElementById("root"));
